import { render, staticRenderFns } from "./ImgInfo.vue?vue&type=template&id=fbef9408&"
import script from "./ImgInfo.vue?vue&type=script&lang=js&"
export * from "./ImgInfo.vue?vue&type=script&lang=js&"
import style0 from "./ImgInfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ImgInfo.vue"
export default component.exports